import ProtectedRoute from '@bumble/app/components/ProtectedRoute';
import { MfaContext } from '@bumble/app/context';
import { useAccount } from '@bumble/app/hooks/use-account';
import {
  Account,
  AppServices,
  Billing,
  Contacts,
  Dashboard,
  EndpointNodeGroups,
  EndpointNodes,
  Endpoints,
  IamUsers,
  NotFound,
  Operations,
  Profile,
  Routers,
  ServiceNodeGroups,
  ServiceNodes,
  UserAgents,
  Support,
  Entities,
  Histories,
  RemoteConsoleAccess,
  PDUManagement,
  CellularWAN,
  SharedDataPool,
  NetworkAccess,
  Documents,
  AgentAnalyzer,
} from '@bumble/app/pages';
import {
  Authenticate,
  ForgotPassword,
  Login,
  Logout,
  MultiFactorAuth,
  Register,
  ResendVerification,
  ResetPassword,
  SetPassword,
} from '@bumble/app/pages/registration';
import { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { MainDashboard } from './pages/MainDashboard';

const Routing = () => {
  const mfaContext = useContext(MfaContext);
  const { session } = useAccount();
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/login-mfa"
        element={
          mfaContext && mfaContext?.user ? <MultiFactorAuth /> : <Navigate to="/main-dashboard" />
        }
      />
      <Route path="/logout" element={<Logout />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password-template" element={<ResetPassword />} />
      <Route path="/new-iam-user-setup-template" element={<SetPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/resend-verification" element={<ResendVerification />} />
      <Route path="/idp-login" element={<Authenticate />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app-services"
        element={
          <ProtectedRoute>
            <AppServices />
          </ProtectedRoute>
        }
      />
      <Route
        path="/endpoints"
        element={
          <ProtectedRoute>
            <Endpoints />
          </ProtectedRoute>
        }
      />
      <Route
        path="/service-nodes"
        element={
          <ProtectedRoute>
            <ServiceNodes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/service-node-groups"
        element={
          <ProtectedRoute>
            <ServiceNodeGroups />
          </ProtectedRoute>
        }
      />
      <Route
        path="/endpoint-nodes"
        element={
          <ProtectedRoute>
            <EndpointNodes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/endpoint-node-groups"
        element={
          <ProtectedRoute>
            <EndpointNodeGroups />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-agents"
        element={
          <ProtectedRoute>
            <UserAgents />
          </ProtectedRoute>
        }
      />
      <Route
        path="/contacts"
        element={
          <ProtectedRoute>
            <Contacts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/main-dashboard"
        element={
          <ProtectedRoute>
            <MainDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/routers"
        element={
          <ProtectedRoute>
            <Routers />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/ethernet-devices"
        element={
          <ProtectedRoute>
            <EthernetDevices />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/cellular-wan"
        element={
          <ProtectedRoute>
            <CellularWAN />
          </ProtectedRoute>
        }
      />
      <Route
        path="/shared-data-pool"
        element={
          <ProtectedRoute>
            <SharedDataPool />
          </ProtectedRoute>
        }
      />
      <Route
        path="/remote-access"
        element={
          <ProtectedRoute>
            <RemoteConsoleAccess />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pdu-management"
        element={
          <ProtectedRoute>
            <PDUManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/network-access"
        element={
          <ProtectedRoute>
            <NetworkAccess />
          </ProtectedRoute>
        }
      />
      <Route
        path="/agent-analyzer"
        element={
          <ProtectedRoute>
            <AgentAnalyzer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operations"
        element={
          <ProtectedRoute>
            <Operations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/support"
        element={
          <ProtectedRoute>
            <Support />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documents"
        element={
          <ProtectedRoute>
            <Documents />
          </ProtectedRoute>
        }
      />
      <Route
        path="/entities"
        element={
          <ProtectedRoute>
            <Entities />
          </ProtectedRoute>
        }
      />
      <Route
        path="/iam"
        element={
          <ProtectedRoute>
            <IamUsers />
          </ProtectedRoute>
        }
      />
      {session?.session_type !== 'iam_user' && (
        <Route
          path="/billing"
          element={
            <ProtectedRoute>
              <Billing />
            </ProtectedRoute>
          }
        />
      )}
      <Route
        path="/histories"
        element={
          <ProtectedRoute>
            <Histories />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <NotFound />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default Routing;
